export default "__VITE_ASSET__DHJD$Tyh__"